import Global from '@/scripts/Global'
import SessionManager from '@/Manager/Session.manager'
import VueSignals from '@/scripts/VueSignals'
import config from '@/scripts/config'
import ChannelThumbNail from '@/components/LeftSidebar/ChannelThumbNail/ChannelThumbNail.vue';
import {
    serverBus
} from '@/main'

export default {
    name: 'DefaultChannels',
    data: function() {
        return {
            directChannelId: VueSignals.DRAFT_CHANNEL_ID,
            defaultUserImage: config.DEFAULT_USER_IMAGE,
        }
    },
    props: {
        channels: Array,
        activeChannelDoc: Object,
        AlertedChannelsList: Array,
        arrMentions: Array,
        loggedInUserDoc: Object,
        withMessagePreview: {
            type: Boolean,
            default: false
        }
    },
    filters: {
        formatName(name) {
            return name ? (name.length >= 15 ? `${name.slice(0,15)}..` : name) : '';
        }
    },
    components: {
        ChannelThumbNail
    },
    watch: {
        AlertedChannelsList(value) {
            // Check if the current channel is opened and remove the channel
            // if it is the case
            for (var i = value.length - 1; i >= 0; i--) {
                if(value[i] === this.activeChannelDoc.channel_id) {
                    value.splice(i, 1);
                    this.AlertedChannelsList = value;
                    return;
                }
            }
        }
    },
    mounted() {
        serverBus.$on(VueSignals.REMOVE_ALL_MENTIONS, (channel_id) => {
            for (let k = 0; k < this.arrMentions.length; k++) {
                if (this.arrMentions[k].channel_id == channel_id) {
                    this.arrMentions[k].count = 0
                }
                Global.setFaviconNormal()
                for (let i = 0; i < this.AlertedChannelsList.length; i++) {
                    if (this.AlertedChannelsList[i] == channel_id) {
                        this.AlertedChannelsList.splice(i, 1)
                        break
                    }
                }
            }
        })
    },
    methods: {
        loadChannel(channel_id) {
            Global.globalValue(VueSignals.LOADED_CHANNEL_ID, channel_id)
        },
        LoadDraftChannel() {
            SessionManager.ActivateDraftChannel()
        },
        getLeftlogo(name) {
            switch (name) {
                case 'CloudBot':
                    return 'fa-robot';
                case 'Feedback':
                    return 'fa-question-circle';
                default:
                    return 'fa-comment';
            }
        },
        getReachability(channel) {
            if (channel.channel_name == 'CloudBot' || channel.channel_name == 'Feedback') {
                return 'online';
            } else {
                let user_id = channel.user_ids.filter(id => id !== SessionManager.getLoggedInUserId())[0];
                let reachability = this.getUserData(user_id).reachability;
                return reachability ? reachability : 'offline'
            }
        },
        getUserData(user_id) {
            if (user_id != SessionManager.getLoggedInUserId()) {
                let user = SessionManager.getUser(user_id)
                if (typeof user == 'undefined') {
                    return
                }
                if (this.activeChannelDoc.hasOwnProperty('removed_users')) {
                    if (this.activeChannelDoc.removed_users.indexOf(user.user_id) > -1) {
                        user.removed = true
                    } else {
                        user.removed = false
                    }
                }
                return user
            } else if (user_id == SessionManager.getLoggedInUserId()) {
                return SessionManager.getLoggedInUser()
            }
        }
    }
}
